import { useTranslation } from 'react-i18next';
import { DownloadOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { Button } from '@/ui';
import { pickThemeFontStyles } from '@/theme';

interface IExportCsvButtonProps {
  disabled?: boolean;
  onClick: () => void;
  label?: string;
}

const StyledExportButton = styled(Button)`
  &&&.template-button {
    ${pickThemeFontStyles('14', '20', 'SEMI_NORMAL')};
    padding: 7px 1rem;
    height: auto;

    .anticon {
      font-size: 13px;
    }
  }
`;

const ExportCsvButton = ({ disabled, onClick, label }: IExportCsvButtonProps) => {
  const { t } = useTranslation(['dashboard']);

  return (
    <StyledExportButton
      type="primary"
      size="small"
      icon={<DownloadOutlined />}
      disabled={disabled}
      onClick={onClick}
      className="no-print"
    >
      {label ?? t('main_metrics_export')}
    </StyledExportButton>
  );
};

export default ExportCsvButton;
